/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getRouters1 } from '@/api/common'
import { RouterModule } from '@/store/modules/router'
import { UserModule } from '@/store/modules/user'
import { getRouters2, loginOut, getDownloadList } from '@/api/common'
import { MessageModule } from '@/store/modules/message'
import { eventBus, EventType } from '@/utils/eventBus'

@Component({})
export default class CrmHeader extends Vue {
    // ------变量声明------
    routers1 = []
    badgeShow = false // 未读消息数量
    socket = null
    time = null
    downLoadDrawerShow = false
    downLoadFileList = []
    fileListLoading = false
    page = 1
    total = 0

    // ------生命周期------
    created() {
        this.initHeadMenu()
    }

    // ------计算属性------
    get activePath() {
        const path = '/' + this.$route.fullPath.split('/')[1]
        return path
    }
    get UserName() {
        return UserModule.userName
    }
    get userId() {
        return UserModule.userId
    }

    get messageBadge() {
        return MessageModule.messageBadge
    }

    get remindBadge() {
        return MessageModule.remindBadge
    }


    // ------方法定义------
    initSocket() {
        // none
    }

    // 初始化菜单
    async initHeadMenu() {
        const data: any = await getRouters1()
        this.routers1 = data.menuList
        RouterModule.SET_ROUTERS1_LIST(data.menuList)
    }
    // 点击一级路由的时候
    async clickRouters1(item: { uri: string; id: number; name: string }) {
        RouterModule.setRouter1(item)
        const data: any = await getRouters2({ id: item.id })
        RouterModule.SET_PATHCHILDRENS(data.menuList)
        if (data.menuList.length > 0) {
            let path = item.uri
            path += '/' + data.menuList[0].uri
            this.$router.push(path)
            this.badgeShow = false
        } else {
            this.$router.push(item.uri)
        }
        // 触发菜单切换事件，更新权限
        eventBus.$emit(EventType.MENU_CHANGED, { menuName: item.name })
    }
    async exitSafely() {
        window.sessionStorage.clear()
        await loginOut()
        let href = ''
        if (process.env.NODE_ENV === 'development') {
            href = 'http://192.168.0.138:8080/login'
        } else {
            if (origin.indexOf('-testserver') === -1) {
                href = 'https://center.gecacademy.cn/home'
            } else {
                href = 'https://center-testserver.gecacademy.cn/home'
            }
        }
        window.location.href = href
    }

    async getDownloadList() {
        this.fileListLoading = true
        const { allNum, downloadList } = await getDownloadList({ limit: 20, page: this.page }) as unknown as { downloadList: { name: string; url: string }[], allNum: number }
        this.downLoadFileList = downloadList
        this.total = allNum
        this.fileListLoading = false
    }

    pageChange(page: number) {
        this.page = page
        this.getDownloadList()
    }

    @Watch('userId')
    handleWatchUserId() {
        this.initSocket()
    }

    @Watch('downLoadDrawerShow')
    downLoadDrawerShowChange(newVal) {
        if (newVal) {
            this.getDownloadList()
        }
    }
}
